import React, { useState } from 'react';

import axios from 'axios';
import Cookies from 'js-cookie';
import{useMutation,commitMutation} from 'react-relay';
import { fetchQuery } from 'relay-runtime';
import graphql from "babel-plugin-relay/macro";
import { RelayNetworkLayer,urlMiddleware,authMiddleware } from 'react-relay-network-modern';
import { Environment,Network,RecordSource,Store } from 'relay-runtime';


function getSessionStorageOrDefault(key, defaultValue) {
    const stored = sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);
  }


const AuthBaseUrl = process.env.REACT_APP_APPLICATION_URL + "/graphql/";
 //const AuthBaseUrl = 'http://127.0.0.1:8000/graphql/';

 const verifyTokenMutation = graphql`
mutation authApiService_verifyTokenMutation($token:String!) {
    verifyToken(token: $token) {
        payload
      }
}
`;  
const loginUserMutation = graphql`
mutation authApiService_loginUserMutation($username:String!,$password:String!) {
    tokenAuth(username: $username, password : $password) {
        token
      }
}
`;  
const allUserTokenQuery = graphql`
query authApiService_allUserTokenQuery {
    allUsertokens {
        edges {
            node {
                id
                token
                description
            }
        }
    }
}
`
const allUserQuery = graphql`
query authApiService_allUserQuery ($username_Icontains:String!){
    allUsers(username_Icontains: $username_Icontains) {
        edges {
            node {
                id
                username
                email
                firstName
                lastName
                firstName
                lastName
                isStaff
                isActive
                isSuperuser
                groups {
                    edges {
                        node {
                            id
                            name
                        }
                    }
                }
                permissions {
                    codename
                    name
                  }
            }
        }
    }
}
`
const refreshTokenMutation = graphql`
mutation authApiService_refreshTokenMutation($token:String!) {
    refreshToken(token: $token) {
        token
      }
}
`; 
const updateUserMutation = graphql`
mutation authApiService_updateUserMutation($input:UpdateUserInput!) {
    updateUser(input: $input) {
        user {
            id
            email
            firstName
            lastName
          }
      }
}
`; 

const authApiServiceExtendedUserDataQuery = graphql`
query authApiServiceExtendedUserDataQuery ($id:ID!){
    user (id: $id) {
        id
        username
        firstName
        lastName
        email
        groups {
                edges {
                    node {
                        id
                        name
                    }
                }
            }
    }
    }
  `


const authApiServiceAllStaticContentUrlsQuery = graphql`
query authApiServiceAllStaticContentUrlsQuery {
    allStaticcontenturls {
      edges {
        node {
          url
        }
      }
    }
  }
`


const setnewEnvironmentForUserToken = (token) =>{
    const fetchGraphQl = async(params,variables) => {
        const response = await fetch(AuthBaseUrl,{
            method:'POST',
            headers:{
                'Content-Type':'application/json',
                'Authorization': 'JWT ' + token
            },
            body:JSON.stringify({
                query : params.text,
                variables
            }),
        });
        return await response.json();
    };
    const environment = new Environment({
        network: Network.create(fetchGraphQl),
        store: new Store(new RecordSource())
    });
    return environment;

 }




export default {

    loginUserMutationApi: async (environment,name,pwd) =>{
        const variables = {
                username : name,
                password : pwd
        }
        return new Promise ((resolve,reject) =>{
            commitMutation(environment,{
                mutation:loginUserMutation,
                variables:variables,
                onCompleted:(response,errors) => {
                    resolve(response)
                },
                onError:(error) =>{
                    reject(error);
                    console.log("response eroor",error)
                }
            });
        })
    } ,

    verifyLoginMutationApi: async (environment,token) =>{
    const variables = {token,};
    return new Promise ((resolve,reject) =>{
        commitMutation(environment,{
            mutation:verifyTokenMutation,
            variables:variables,
            onCompleted:(response,errors) => {
                resolve(response)
            },
            onError:(error) =>{
                reject(error);
                console.log("response eroor",error)
            }
        });
    })
    },

    getAllUserTokenQueryApi:async (token) =>{
       const variables = {};
       let environment = setnewEnvironmentForUserToken(token);
       return new Promise ((resolve,reject) =>{
        fetchQuery(environment,allUserTokenQuery,variables)
        .toPromise()
        .then((response) =>{
           const userTokens = response.allUsertokens?.edges?.map((edge) => edge.node);
           resolve(userTokens)
       })
       .catch((error) => {
       console.log("error",error)
       reject(error)
       }) ;
       })
    },


    getAllUserQueryApi:async (name) =>{    
        // const token = Cookies.get('token');

        const token = getSessionStorageOrDefault('p3token', null)
        let environment = setnewEnvironmentForUserToken(token);
        const variables = {
            username_Icontains:name
        };
        return new Promise ((resolve,reject) =>{
            fetchQuery(environment,allUserQuery,variables)
            .toPromise()
            .then((response) =>{
                resolve(response);
             })
             .catch((error) => {
             console.log("error",error)
             reject(error)
             }) ;
        })
     },

     refreshTokenApi:async (environment,token) =>{
        const variables = {token,};
        return new Promise ((resolve,reject) =>{
            commitMutation(environment,{
                mutation:refreshTokenMutation,
                variables:variables,
                onCompleted:(response,errors) => {
                    resolve(response)
                },
                onError:(error) =>{
                    reject(error);
                }
            });
        })

     },
     
     updateUserInfoApi : (userDetail,token) =>{
        const variables = {
            input : {
                username:userDetail.username,
                email: userDetail.email, 
                firstName:userDetail.firstName,
                lastName: userDetail.lastName,
                password: userDetail.password,
            }
        }
        let environment = setnewEnvironmentForUserToken(token);

        return new Promise ((resolve,reject) =>{
            commitMutation(environment,{
                mutation:updateUserMutation,
                variables:variables,
                onCompleted:(response,errors) => {
                    resolve(response)
                },
                onError:(error) =>{
                    reject(error);
                    console.log("response eroor",error)
                }
            });
        })

     },

     setnewEnvironmentForUserToken : (token) =>{
        const fetchGraphQl = async(params,variables) => {
            const response = await fetch(AuthBaseUrl,{
                method:'POST',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization': 'JWT ' + token
                },
                body:JSON.stringify({
                    query : params.text,
                    variables
                }),
            });
            return await response.json();
        };
        const environment = new Environment({
            network: Network.create(fetchGraphQl),
            store: new Store(new RecordSource())
        });
        return environment;

     },

     
     getAllUserExtendedQueryApi : async () =>{    
        // const token = Cookies.get('token');

        const token     = getSessionStorageOrDefault('p3token', null)
        let environment = setnewEnvironmentForUserToken(token);
        const id        = getSessionStorageOrDefault('userid', null)

        const variables = {
            id:id
        };
        return new Promise ((resolve,reject) =>{
            fetchQuery(environment,authApiServiceExtendedUserDataQuery,variables)
            .toPromise()
            .then((response) =>{
                resolve(response);
             })
             .catch((error) => {
             console.error("error",error)
             reject(error)
             }) ;
        })
     },


     getAllStaticContentUrlsApi : async () =>{    
        // const token = Cookies.get('token');

        const token     = getSessionStorageOrDefault('p3token', null)
        let environment = setnewEnvironmentForUserToken(token);
        const id        = getSessionStorageOrDefault('userid', null)

        const variables = {
            id:id
        };
        return new Promise ((resolve,reject) =>{
            fetchQuery(environment,authApiServiceAllStaticContentUrlsQuery,variables)
            .toPromise()
            .then((response) =>{
                resolve(response);
             })
             .catch((error) => {
             console.error("error",error)
             reject(error)
             }) ;
        })
     },

    // LoginUser: (name, pwd) => {
    //     const boperationName = "getToken"
    //     const queryname = `
    //     mutation ${boperationName} {
    //         tokenAuth(username: "${name}", password: "${pwd}") {
    //             token
    //           }
    //     }
    //     `;
    //     const options = {
    //         method: 'POST',
    //         url:AuthBaseUrl,
    //         headers: {
    //             'content-type': 'application/json'
    //         },
    //         data: {
    //             query: queryname,
    //             variables: {}
    //         }
    //     };
    //     return axios
    //         .request(options)
    //         .then(function (response) {
    //           //  console.log("success", response.data);
    //             return response // Response
    //         })
    //         .catch(function (error) {
    //             console.error("error", error);
    //         });
    // },
    // VerifyLoginUser: (Utoken) => {
    //     const queryname = `
    //     mutation verifyToken {
    //         verifyToken(token: "${Utoken}") {
    //             payload
    //           }
    //     }
    //     `;
    //     const options = {
    //         method: 'POST',
    //         url:AuthBaseUrl,
    //         headers: {
    //             'content-type': 'application/json'
    //         },
    //         data: {
    //             query: queryname,
    //             variables: {}
    //         }
    //     };
    //     return axios
    //         .request(options)
    //         .then(function (response) {
    //             return response // Response
    //         })
    //         .catch(function (error) {
    //             console.error("error", error);
    //         });
    // },

    // GetAllUserToken: (Utoken) => {
    //     const operationName = "allUsertokens"
    //     const queryname = `
    //     query ${operationName} {
    //         allUsertokens {
    //             edges {
    //                 node {
    //                     id
    //                     token
    //                     description
    //                 }
    //             }
    //         }
    //     }
    //     `
    //     const options = {
    //         method: 'POST',
    //         url:AuthBaseUrl,
    //         headers: {
    //             'content-type': 'application/json',
    //             'Authorization': 'JWT ' + Utoken
    //         },
    //         data: {
    //             query: queryname,
    //             variables: {}
    //         }
    //     };
    //     return axios
    //         .request(options)
    //         .then(function (response) {
    //            // console.log("success", response.data);
    //             return response // Response
    //         })
    //         .catch(function (error) {
    //             console.error("error", error);
    //         });

    // },

    // GetAllUsers : (name) =>{
    //     const token = Cookies.get('token');
    //     const operationName = "getUsers"
    //     const queryname = `
    //     query ${operationName} {
    //         allUsers(username_Icontains: "${name}") {
    //             edges {
    //                 node {
    //                     id
    //                     username
    //                     email
    //                     firstName
    //                     lastName
    //                 }
    //             }
    //         }
    //     }
    //     `
    //     const options = {
    //         method: 'POST',
    //         url:AuthBaseUrl,
    //         headers: {
    //             'content-type': 'application/json',
    //             'Authorization': 'JWT ' + token
    //         },
    //         data: {
    //             query: queryname,
    //             variables:{}
    //         }
    //     };

        
    //     return  axios
    //         .request(options)
    //         .then(function (response) {
    //            // console.log("success",response.data);
    //             return response // Response
    //         })
    //         .catch(function (error) {
    //             console.error("error",error);
    //         });
    // },

    // RefreshToken: (tokenval) =>{
    //     const RefreshoperationName = "refreshToken"
    //     const queryname = `
    //     mutation ${RefreshoperationName} {
    //         refreshToken(token: "${tokenval}") {
    //             token,
    //             payload
    //           }
    //     }
    //     `;

    //     const options = {
    //         method: 'POST',
    //         url:AuthBaseUrl,
    //         headers: {
    //             'content-type': 'application/json'
    //         },
    //         data: {
    //             query: queryname,
    //             variables: {}
    //         }
    //     };
    //     return axios
    //         .request(options)
    //         .then(function (response) {
    //             //console.log("success", response.data);
    //             return response // Response
    //         })
    //         .catch(function (error) {
    //             console.error("error", error);
    //         });
    // },
    // UpdateUserInfo: (userDetail,token) =>{
    //     const creatUseroperationName = "createUser"
    //     const queryname = `
    //     mutation ${creatUseroperationName} {
    //         updateUser(input:{
    //             username:"${userDetail.username}",
    //             email: "${userDetail.email}", 
    //             firstName: "${userDetail.firstName}",
    //             lastName: "${userDetail.lastName}",
    //             password: "${userDetail.password}",
    //         }) {
    //             user {
    //                 id
    //                 email
    //                 firstName
    //                 lastName
    //               }
    //           }
    //     }
    //     `;

    //     const options = {
    //         method: 'POST',
    //         url:AuthBaseUrl,
    //         headers: {
    //             'content-type': 'application/json',
    //             'Authorization': 'JWT ' + token
    //         },
    //         data: {
    //             query: queryname,
    //             variables: {}
    //         }
    //     };
    //     return axios
    //         .request(options)
    //         .then(function (response) {
    //            // console.log("success", response.data);
    //             return response // Response
    //         })
    //         .catch(function (error) {
    //             console.error("error", error);
    //         });
    // }
}